import Icon from 'atoms/Icon'
import Text from 'atoms/Text'
import React from 'react'
import PropTypes from "prop-types"

function TextWithIcon({ text, icon, color, iconColor, onClick, className, iconClass, iconSize, direction, textVariant }) {
    return (
        <div className={`flex items-center gap-2 cursor-pointer ${color} ${direction} ${className}`} onClick={onClick}>
            <Text variant={textVariant}>
                {text}
            </Text>
            <Icon 
                icon={icon}
                color={iconColor}
                size={iconSize}
                className={iconClass}
            />
        </div>
    )
};

TextWithIcon.defaultProps = {
    text: 'View more',
    icon: 'chevron_down__l__stroke',
    color: 'text-green-900',
    iconColor: 'green',
    className: '',
    iconClass: '',
    iconSize: 'w-4 h-4',
    direction: 'row',
    onClick: () => false,
    textVariant: 'body'
}

TextWithIcon.propTypes = {
    text: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    iconColor: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    iconSize: PropTypes.string,
    direction: PropTypes.oneOf(['row', 'row-reverse']),
    iconClass: PropTypes.string
};

export default TextWithIcon